import React, { useState, useEffect } from "react";
import { MessageCircle, Menu, X } from "lucide-react";
import { Button } from "./ui/button";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-white/80 backdrop-blur-md border-b border-blue-100 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Brand */}
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center gap-2 group"
          >
            <div className="w-9 h-9 rounded-xl bg-blue-600 flex items-center justify-center shadow-md shadow-blue-600/20 group-hover:scale-105 transition-transform">
              <MessageCircle className="w-5 h-5 text-white" strokeWidth={2.5} />
            </div>
            <span className="text-lg sm:text-xl font-extrabold tracking-tight text-slate-900">
              Live<span className="text-blue-600">Chat</span>
            </span>
          </a>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollTo("features")}
              className="text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors"
            >
              Features
            </button>
            <button
              onClick={() => scrollTo("how-it-works")}
              className="text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors"
            >
              How it works
            </button>
            <button
              onClick={() => scrollTo("download")}
              className="text-sm font-medium text-slate-700 hover:text-blue-600 transition-colors"
            >
              Download
            </button>
          </nav>

          <div className="hidden md:block">
            <Button
              onClick={() => scrollTo("download")}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg px-5 shadow-md shadow-blue-600/20"
            >
              Get Started
            </Button>
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden p-2 rounded-lg text-slate-800 hover:bg-blue-50 transition-colors"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-white border-t border-blue-100 shadow-lg animate-fade-in">
          <div className="px-4 py-4 flex flex-col gap-2">
            <button
              onClick={() => scrollTo("features")}
              className="text-left text-sm font-medium text-slate-700 hover:text-blue-600 py-2"
            >
              Features
            </button>
            <button
              onClick={() => scrollTo("how-it-works")}
              className="text-left text-sm font-medium text-slate-700 hover:text-blue-600 py-2"
            >
              How it works
            </button>
            <button
              onClick={() => scrollTo("download")}
              className="text-left text-sm font-medium text-slate-700 hover:text-blue-600 py-2"
            >
              Download
            </button>
            <Button
              onClick={() => scrollTo("download")}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg w-full mt-1"
            >
              Get Started
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
